import React from 'react';

const JourneyProgressBreadcrumb = ({ currentStage, journey }) => {
  const stages = ['intake', 'framing', 'hypotheses', 'experiment', 'decision'];

  const getStageIcon = (stage) => {
    const icons = {
      intake: '📥',
      framing: '🎯',
      hypotheses: '💭',
      experiment: '🔬',
      decision: '✅',
    };
    return icons[stage] || '•';
  };

  const getStageLabel = (stage) => {
    return stage.charAt(0).toUpperCase() + stage.slice(1);
  };

  const currentStageIndex = stages.indexOf(currentStage || 'intake');

  return (
    <div className="journey-progress-breadcrumb">
      <div className="breadcrumb-container">
        {stages.map((stage, index) => {
          const isCompleted = index < currentStageIndex;
          const isCurrent = index === currentStageIndex;
          const isPending = index > currentStageIndex;

          return (
            <React.Fragment key={stage}>
              <div className={`breadcrumb-item ${isCurrent ? 'current' : ''} ${isCompleted ? 'completed' : ''} ${isPending ? 'pending' : ''}`}>
                <div className="breadcrumb-icon">
                  {isCompleted && '✓'}
                  {isCurrent && getStageIcon(stage)}
                  {isPending && '○'}
                </div>
                <div className="breadcrumb-text">
                  <div className="breadcrumb-stage">{getStageLabel(stage)}</div>
                  <div className="breadcrumb-status">
                    {isCompleted && 'Done'}
                    {isCurrent && 'Current'}
                    {isPending && 'Pending'}
                  </div>
                </div>
              </div>

              {index < stages.length - 1 && (
                <div className={`breadcrumb-arrow ${isCompleted ? 'completed' : ''}`}>→</div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <style>{`
        .journey-progress-breadcrumb {
          margin-bottom: 30px;
          padding: 20px;
          background: linear-gradient(135deg, #f5f9f8 0%, #f9fcfb 100%);
          border-radius: 12px;
          border-left: 4px solid #8FC5B2;
        }

        .breadcrumb-container {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;
          justify-content: center;
        }

        .breadcrumb-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 8px;
          padding: 12px 16px;
          border-radius: 8px;
          background: white;
          border: 2px solid #e0e0e0;
          transition: all 0.3s ease;
          min-width: 100px;
        }

        .breadcrumb-item.completed {
          border-color: #8FC5B2;
          background: #f0fdf8;
        }

        .breadcrumb-item.current {
          border-color: #8FC5B2;
          background: #e8f5f1;
          box-shadow: 0 4px 12px rgba(143, 197, 178, 0.2);
          transform: scale(1.05);
        }

        .breadcrumb-item.pending {
          border-color: #ddd;
          background: #fafafa;
          opacity: 0.6;
        }

        .breadcrumb-icon {
          font-size: 24px;
          font-weight: bold;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .breadcrumb-item.completed .breadcrumb-icon {
          color: #8FC5B2;
        }

        .breadcrumb-item.current .breadcrumb-icon {
          color: #8FC5B2;
        }

        .breadcrumb-item.pending .breadcrumb-icon {
          color: #bbb;
        }

        .breadcrumb-text {
          text-align: center;
        }

        .breadcrumb-stage {
          font-size: 13px;
          font-weight: 600;
          color: #2c3e50;
          margin-bottom: 2px;
        }

        .breadcrumb-item.pending .breadcrumb-stage {
          color: #999;
        }

        .breadcrumb-status {
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          font-weight: 500;
        }

        .breadcrumb-item.completed .breadcrumb-status {
          color: #8FC5B2;
        }

        .breadcrumb-item.current .breadcrumb-status {
          color: #8FC5B2;
        }

        .breadcrumb-item.pending .breadcrumb-status {
          color: #999;
        }

        .breadcrumb-arrow {
          color: #ddd;
          font-size: 16px;
          font-weight: bold;
          margin: 0 4px;
        }

        .breadcrumb-arrow.completed {
          color: #8FC5B2;
        }

        @media (max-width: 768px) {
          .breadcrumb-container {
            flex-direction: column;
            gap: 12px;
          }

          .breadcrumb-arrow {
            transform: rotate(90deg);
            margin: 4px 0;
          }

          .breadcrumb-item {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default JourneyProgressBreadcrumb;
